import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Typography } from '@zapier/design-system';
import { MEDIA_MAX_WIDTH } from '../../constants';
export function Heading({ text, tag: Tag = 'h2', disableStyles, styles, }) {
    var _a;
    return (_jsx(Tag, Object.assign({ css: disableStyles
            ? { font: 'inherit' }
            : Object.assign(Object.assign(Object.assign({}, Typography[(_a = styles === null || styles === void 0 ? void 0 : styles.desktop) !== null && _a !== void 0 ? _a : 'pageHeader5']), ((styles === null || styles === void 0 ? void 0 : styles.tablet) && {
                [MEDIA_MAX_WIDTH.large]: Typography[styles.tablet],
            })), ((styles === null || styles === void 0 ? void 0 : styles.mobile) && {
                [MEDIA_MAX_WIDTH.small]: Typography[styles.mobile],
            })) }, { children: text })));
}
//# sourceMappingURL=Heading.js.map